export const AnalyticsEvents = {
  MainPage: {
    // Done
    ConnectWallet: {
      event: "main_connect_wallet",
      category: "auth",
      label: "Main Connect Wallet Button",
    },
    // Done
    AddDeposit: {
      event: "main_add_deposit",
      category: "deposit",
      label: "Main Add Deposit Button",
    },
    // Done
    WithdrawRewards: {
      event: "main_withdraw_rewards",
      category: "rewards",
      label: "Main Withdraw Rewards Button",
    },
    // Done
    ClaimAirdrop: {
      event: "main_claim_airdrop",
      category: "airdrop",
      label: "Main Claim Airdrop Button",
    },
    // Done
    ViewDeposits: {
      event: "main_view_deposits",
      category: "deposit",
      label: "Main View Deposits Button",
    },
    // Done
    CopyInviteId: {
      event: "main_copy_invite_id",
      category: "referral",
      label: "Main Copy Invite ID Button",
    },
  },

  WithdrawRewardsPage: {
    // Done
    ConnectWallet: {
      event: "withdraw_rewards_connect_wallet",
      category: "auth",
      label: "Withdraw Rewards Connect Wallet Button",
    },
    // Done
    Withdraw: {
      event: "withdraw_rewards_confirm",
      category: "rewards",
      label: "Withdraw Rewards Confirm Button",
    },
  },

  ClaimAirdropPage: {
    // Done
    ConnectWallet: {
      event: "airdrop_connect_wallet",
      category: "auth",
      label: "Airdrop Connect Wallet Button",
    },
    // Done
    Withdraw: {
      event: "airdrop_withdraw",
      category: "airdrop",
      label: "Airdrop Withdraw Button",
    },
  },

  Network: {
    // Done
    Open: {
      event: "network_open",
      category: "navigation",
      label: "Open Network Tab",
    },
    // Done
    ClaimAirdrop: {
      event: "network_claim_airdrop",
      category: "airdrop",
      label: "Network Claim Airdrop Button",
    },
    // Done
    ViewDetailed: {
      event: "network_view_detailed",
      category: "analytics",
      label: "Network View Detailed Button",
    },
    // Done
    CopyInviteId: {
      event: "network_copy_invite_id",
      category: "referral",
      label: "Network Copy Invite ID Button",
    },
  },

  History: {
    // Done
    Open: {
      event: "network_history",
      category: "history",
      label: "Network History Button",
    },
  },

  WeeklyBonus: {
    // Done
    Open: {
      event: "weekly_bonus_open",
      category: "navigation",
      label: "Open Weekly Bonus Tab",
    },
    // Done
    ViewPreviousWeek: {
      event: "weekly_bonus_view_previous",
      category: "bonus",
      label: "View Previous Week Bonus",
    },
    // Done
    Claim: {
      event: "weekly_bonus_claim",
      category: "bonus",
      label: "Claim Weekly Bonus",
    },
  },

  Settings: {
    // Done
    Open: {
      event: "settings_open",
      category: "navigation",
      label: "Open Settings Tab",
    },
    // Done
    ConnectWallet: {
      event: "settings_connect_wallet",
      category: "auth",
      label: "Settings Connect Wallet Button",
    },
    // Done
    Support: {
      event: "settings_support",
      category: "support",
      label: "Settings Support Button",
    },
  },
} as const;
